import { DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap"
import React from "react"

export const credentialsColumns = (activeColumn, isShare, deleteCred, getViewData, handleEdit) => [
    {
        Header: "ID",
        accessor: "id",
        id: "id",
        classNames: "col-md-1 text-center",
        isCopyIcon: false,
        isLink: false,
        isShortIcon: true,
        Cell: row => <div style={{ textAlign: "center" }}>{row.value}</div>,
    },
    ...(activeColumn !== undefined && activeColumn.length !== 0
        ? activeColumn
        : [
            {
                Header: "",
                accessor: "hh",
                classNames: "col-md-10",
                isCopyIcon: true,
            },
        ]),
    {
        Header: "Action",
        accessor: "action",
        classNames: "text-center col-md-1",
        isCopyIcon: false,
        isLink: false,
        Cell: cellProps => {

            return (
                <div className="d-flex justify-content-center">
                    <button
                        onClick={() => {
                            getViewData(cellProps.row.original)
                        }}
                        className="btn btn-sm me-1 btn-outline-secondary"
                    >
                        <i className="fas fa-eye"></i>
                    </button>
                    <button
                        onClick={() => {
                            isShare(cellProps)
                        }}
                        className="btn btn-sm me-1 btn-outline-secondary"
                    >
                        <i className="fa fa-share-alt"></i>
                    </button>

                    <UncontrolledDropdown
                        className="dropdown"
                        style={{ width: "29px" }}
                    >
                        <DropdownToggle
                            className="btn btn-sm btn-outline-secondary w-100"
                            color="white"
                        >
                            <i className="mdi mdi-dots-horizontal"></i>
                        </DropdownToggle>
                        <DropdownMenu className="dropdown-menu-end">
                            <button
                                type="button"
                                onClick={() => {
                                    handleEdit(cellProps.row.original)
                                }}
                                title="edit lead"
                                className="dropdown-item"
                            >
                                <i className="fas fa-pencil-alt pr-10"></i> Edit Credentials
                            </button>

                            <a
                                onClick={() => {
                                    deleteCred(cellProps.row.original.id)
                                }}
                                className="dropdown-item"
                                title="delete"
                            >
                                <i className="fas fa-trash-alt pr-10 text-danger"></i>{" "}
                                Delete Credentials
                            </a>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </div>
            )
        },
    },
]